import { Fragment, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Button, DatePicker, Input, Modal, Select, Space, Form } from "antd"
import { useForm } from "antd/lib/form/Form"
import { baseAxiosComplete, baseAxiosNoInfo } from "../../../tool/axios"
import moment from "moment"
import _ from 'lodash'

const { Option } = Select

interface Prop {
    checkInID?: string
    onChange?: () => void
}

export default function (prop: Prop) {

    const param: { check_in_id: string } = useParams()

    const [visible, setVisible] = useState<boolean>(false)
    const [form] = useForm()

    const [types, setTypes] = useState<any[]>([])
    const [foods, setFoods] = useState<any[]>([])

    const [foodID1, setFoodID1] = useState<string[]>([])
    const [foodID2, setFoodID2] = useState<string[]>([])

    useEffect(() => {
        baseAxiosNoInfo('/cooking_center/global/food_type_list').then((res: any) => {
            res && setTypes(res)
        })
    }, [])

    const onFinish = () => {
        baseAxiosComplete.post('/cooking_center/customer/dining_reception/add', {
            check_in_id: param.check_in_id,
            receive_date: form.getFieldValue('receive_date') && form.getFieldValue('receive_date').format('YYYY-MM-DD'),
            guomin_food_item_id: foodID1,
            jinji_food_item_id: foodID2,
            has_shuizhong: form.getFieldValue('has_shuizhong'),
            paibian_status: form.getFieldValue('paibian_status'),
            other_exception: form.getFieldValue('other_exception')
        }).then(res => {
            if (res.status === 0) {
                setVisible(false)
                prop.onChange && prop.onChange()
            }
        })
    }

    return <Fragment>
        <Button type="primary" style={{ marginLeft: 16, marginBottom: 16 }} size="small" onClick={() => { setVisible(true) }}>随餐接待</Button>

        {/* 膳食中心 -> 营养膳食 -> 入住客户管理 -> 客户详情 -> 录入随餐接待 */}
        <Modal title="录入随餐接待" width={600} visible={visible} onCancel={() => { setVisible(false) }} onOk={onFinish}>
            <div>
                <Form form={form}>
                    <Form.Item label="回访日期" name="receive_date" required>
                        <DatePicker disabledDate={(current: any) => {
                            return current > moment()
                        }} />
                    </Form.Item>

                    <Form.Item label="过敏食材"  >
                        <Space>
                            <Select placeholder="选择食材分类" onChange={(v: string) => {
                                baseAxiosNoInfo('/cooking_center/global/food_item_list', {
                                    params: {
                                        food_type_id: v
                                    }
                                }).then(((res: any) => {
                                    res && setFoods(res)
                                }))
                            }}>
                                {types.map((el: any) => <Option key={el.food_type_id} value={el.food_type_id}>{el.food_type_name}</Option>)}
                            </Select>

                            <Select placeholder="选择食材" style={{ minWidth: 150 }} mode="multiple" onChange={(v: string[]) => {
                                setFoodID1(v)
                            }} >
                                {foods.map((el: any) => <Option key={el.food_item_id} value={el.food_item_id}>{el.food_item_name}</Option>)}
                            </Select>
                        </Space>
                    </Form.Item>

                    <Form.Item label="禁忌食材" >
                        <Space>
                            <Select placeholder="选择食材分类" onChange={(v: string) => {
                                baseAxiosNoInfo('/cooking_center/global/food_item_list', {
                                    params: {
                                        food_type_id: v
                                    }
                                }).then(((res: any) => {
                                    res && setFoods(res)
                                }))
                            }}>
                                {types.map((el: any) => <Option key={el.food_type_id} value={el.food_type_id}>{el.food_type_name}</Option>)}
                            </Select>

                            <Select placeholder="选择食材" style={{ minWidth: 150 }} mode="multiple" onChange={(v: string[]) => {
                                setFoodID2(v)
                            }} >
                                {foods.map((el: any) => <Option key={el.food_item_id} value={el.food_item_id}>{el.food_item_name}</Option>)}
                            </Select>
                        </Space>
                    </Form.Item>

                    <Form.Item label="水肿情况" name="has_shuizhong" required>
                        <Select >
                            <Option key={1} value={1}>有</Option>
                            <Option key={0} value={0}>无</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item label="排便情况" name="paibian_status" required>
                        <Select >
                            <Option key={0} value={0}>便秘</Option>
                            <Option key={1} value={1}>正常</Option>
                            <Option key={2} value={2}>稀便</Option>
                            <Option key={3} value={3}>腹泻</Option>
                            <Option key={4} value={4}>其他</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item label="其他异常" name="other_exception">
                        <Input />
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    </Fragment>
}